import { ShareType } from "../types";

const isValidDataTypes = (
	supportedTypes: ShareType[] | readonly ShareType[],
	data: ShareType[],
) => {
	const isValid = data.every((type) => supportedTypes.includes(type)) && data.length > 0;
	return isValid;
};

export default isValidDataTypes;
